import { render, staticRenderFns } from "./VerticalLayoutVideo.vue?vue&type=template&id=f43ff8a0&scoped=true&"
import script from "./VerticalLayoutVideo.vue?vue&type=script&lang=js&"
export * from "./VerticalLayoutVideo.vue?vue&type=script&lang=js&"
import style0 from "./VerticalLayoutVideo.vue?vue&type=style&index=0&id=f43ff8a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43ff8a0",
  null
  
)

export default component.exports